import { GoogleLogo } from "@phosphor-icons/react";

export default function GoogleButton({ context, label, testid }) {
    const handleClick = () => {
        localStorage.setItem("google_auth_context", context);
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/portal";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };
    return (
        <button
            type="button"
            onClick={handleClick}
            data-testid={testid}
            className="w-full flex items-center justify-center gap-3 bg-white border border-racing-line hover:border-racing-red text-neutral-900 text-xs uppercase tracking-[0.2em] py-4 transition-colors duration-300"
        >
            <GoogleLogo size={20} weight="bold" className="text-racing-red" /> {label}
        </button>
    );
}
